const mediaQuery = ref({
  isSmall: false,
  isMedium: false,
  isLarge: false,
  isExtraLarge: false,
  isApp: isApp(),
})

function updateMediaQuery() {
  mediaQuery.value = {
    isSmall: globalThis.matchMedia('(min-width: 440px)').matches,
    isMedium: globalThis.matchMedia('(min-width: 768px)').matches,
    isLarge: globalThis.matchMedia('(min-width: 1024px)').matches,
    isExtraLarge: globalThis.matchMedia('(min-width: 1280px)').matches,
    isApp: isApp(),
  }
}

// Use a ref to track if the listener is already added
const isListenerAdded = ref(false)

// Only add the listener once globally
if (!isListenerAdded.value) {
  globalThis.addEventListener('resize', updateMediaQuery)
  isListenerAdded.value = true
}

updateMediaQuery()

export default () => mediaQuery
